module.exports = __webpack_public_path__ + "img/dotGroup.d46735c7.svg";